<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/landscaping-and-vegetation">Add New Plant/Trees
                Information</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">View List of Plants/Trees</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">View List of Plants/Trees</h2>
    </div>
    <div
        class="search_bar border-top border-bottom border-light mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mb-4 mb-md-5">
        <form class="search_form">
            <svg-icon src="../../../assets/images/icons/search.svg"></svg-icon>
            <input type="text" name="searchText" id="searchText" class="search_field" placeholder="Search by Plant Name"
                [(ngModel)]="searchText" (keyup)="searchByText(searchText)" (search)="searchByText(searchText)"
                #searchcontact="ngModel">
            <button type="submit" class="d-none"></button>
        </form>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}}
            Plant{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="foodvendorView">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedPlants" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select and download QR
                    codes</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <!-- <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button (click)="downloadAllQrCode($event);" ngbDropdownItem>Download all QR codes</button>
                </div> -->
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button (click)="downloadAllQrCodesAsPdfZip($event);" ngbDropdownItem>Download all QR codes</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let plant of newPlants | paginate: { itemsPerPage: 20,
            currentPage: page, totalItems:newPlants?.length }; let i=index ">
            <div class="bg-lighter p-3 rounded d-flex align-items-center column-gap-2">
                <div class="custom-control custom-checkbox flex-shrink-0" *ngIf="foodvendorView">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="plant.isSelected" name="list_name"
                        [id]="plant.vegetationId + 'list_name'" value="{{plant.vegetationId}}"
                        (change)="isAllSelected()">
                    <label [for]="plant.vegetationId + 'list_name'" class="custom-control-label cursor-pointer"></label>
                </div>
                <div>
                    <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer"
                        (click)="goToPlantDetails(plant.vegetationId)">
                        {{plant.vegetationName}}</h3>

                    <!-- <a href="{{plant.qrCodePath}}"
                        (click)="openModal(plant.qrCodePath, plant.vegetationName, plant.vegetationId)"
                        class="font-weight-bold small mb-0 cursor-pointer" target="_self" download>Download QR Code</a> -->

                    <span
                        (click)="openModal(plant.qrCodePath, plant.vegetationName, plant.vegetationId, plant.species, plant.parkName)"
                        class="font-weight-bold small mb-0 cursor-pointer">
                        <!-- <span
                        class="font-weight-bold small mb-0 cursor-pointer"
                        (click)="downloadQrCodeAsPdf(plant.qrCodePath, plant.vegetationName)"
                      >  -->
                        Download QR Code</span>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="custom_pagination mt-4 mt-md-5 small">
        <div class="border border-light">
            <ngb-pagination [collectionSize]="1" [(page)]="page">
                <ng-template ngbPaginationPrevious>
                    <svg-icon src="../../../assets/images/icons/prev.svg"></svg-icon>
                </ng-template>
                <ng-template ngbPaginationNext>
                    <svg-icon src="../../../assets/images/icons/next.svg"></svg-icon>
                </ng-template>
            </ngb-pagination>
            <div class="page_numbers">
                {{page}}/{{totalPages}}
            </div>
        </div>
    </div> -->

    <!-- <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="plants?.length > 20"> -->
    <div class="custom_pagination mt-4 mt-md-5 small">
        <div class="border border-light">
            <pagination-controls class="pagination" (pageChange)="handelVegitationPlantList($event)"
                class="d-flex justify-content-center">
            </pagination-controls>
            <div class="page_numbers">
                {{indexPage}}/{{paginationCount(plants?.length)}}</div>
        </div>
    </div>

    <div style="display: none;"><app-bulk-qr-code-download></app-bulk-qr-code-download></div>

    <!-- <div style="display: none;">
        <div id="allQrCodeAll" #allQrCodeAll>
            <div class="generate_pdf html2pdf__page-break" *ngFor="let qrplant of checkedPlantsListOnlyQr; let j=index">
                <div class="card_header">
                    <a [routerLink]="['/']">
                        <img src="./assets/images/capitaland-cla-logo.png" alt="">
                    </a>
                    <a [routerLink]="['/']">
                        <img src="./assets/images/logo-cla.png" alt="">
                    </a>
                </div>
                <p class="_location"> {{qrplant.parkName}}</p>
                <div class="_content">
                    <h3>{{qrplant.vegetationName}}</h3>
                    <p>({{qrplant.species}})</p>
                    <div class="_qr">
                        <img [src]="qrplant.qrCodePath" alt="qrcode" class="mb-3 mb-md-4">
                    </div>
                    <small>Scan this QR Code to view details about the plant</small>
                </div>
            </div>
        </div>
    </div> -->


    <!-- <div class="d-flex justify-content-center pagination-section mt-4">
        <div class="row d-flex pagination-border">
            <pagination-controls class="pagination" previousLabel="" (pageChange)="handelVegitationPlantList($event)"
                nextLabel="" class="d-flex justify-content-center">
            </pagination-controls>
            <div class="pr-3 ratio-class pt-1">
                {{indexPage}}/{{paginationCount(plants?.length)}}</div>
        </div>
    </div> -->

</div>